<template>
  <div>
    <div
      v-if="products.length > 0"
      class="section-header"
    >
      <span class="title">Featured Products</span>
      <button v-if="showButton" @click="previous">
        <i class="fa-solid fa-arrow-left" />
      </button>
      <button v-if="showButton" @click="next">
        <i class="fa-solid fa-arrow-right" />
      </button>
    </div>
    <ProductGrid :products="visibleProducts" />
  </div>
</template>

<script>
import ProductGrid from "../product_grid";
const NUMBER_OF_PRODUCTS_TO_SHOW = 5;

export default {
  components: {ProductGrid},
  props: {
    products: {
      required: true, type: Array, default() {
        return [];
      },
    },
  },
  data() {
    return {
      index: 0,
    };
  },
  computed: {
    showButton: function () {
      return this.products.length > NUMBER_OF_PRODUCTS_TO_SHOW;
    },
    visibleProducts: function () {
      if (this.products.length < NUMBER_OF_PRODUCTS_TO_SHOW) {
        return this.products;
      } else if (this.index + NUMBER_OF_PRODUCTS_TO_SHOW < this.products.length) {
        return this.products.slice(this.index, this.index + NUMBER_OF_PRODUCTS_TO_SHOW);
      } else {
        return this.products.slice(this.index, this.index + NUMBER_OF_PRODUCTS_TO_SHOW).concat(this.products.slice(0, this.index + NUMBER_OF_PRODUCTS_TO_SHOW - this.products.length));
      }
    },
  },
  methods: {
    previous: function () {
      if (this.index === 0) {
        this.index = this.products.length - 1;
      } else {
        this.index = this.index -1;
      }
    },
    next: function () {
      if (this.index === this.products.length - 1) {
        this.index = 0;
      } else {
        this.index = this.index + 1;
      }
    },
  },
};
</script>
